import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleUsageUtils } from '../../util/article-usage-utils';
import { MetaElementUsageIdentityVO } from '@shared/vo/meta-element.vo';
import { InsertArticleHelper } from '../insert-article.helper';
import { Connection } from '@3d-scene/model3d/connection';
import { ConnectionInfoUtils } from '@3d-scene/model3d/util/connection-info-utils';

export class ReplaceDynamicArticleUtils {

  public static isArticleConnectedToAcceptingId(container: ArticleContainer, acceptingId: MetaElementUsageIdentityVO): boolean {
    const parentConnectionUsageIds: MetaElementUsageIdentityVO[] = ArticleUsageUtils.getBackwardConnectedConnectionUsageIds(
      container.articleUsage);
    return parentConnectionUsageIds.length > 0 && acceptingId.equals(parentConnectionUsageIds[0]);
  }

  public static isSuitableInsertHelper(insertHelper: InsertArticleHelper): boolean {
    return !!insertHelper && this.isSuitableRangeOnLineConnection(insertHelper.acceptingConnection);
  }

  public static isSuitableRangeOnLineConnection(connection: Connection): boolean {
    return !!connection && ConnectionInfoUtils.isDefaultRangeOnLineConnection(connection.metaElementVO);
  }
}
